// extracted by mini-css-extract-plugin
export var radioInputRow = "K_vt";
export var radioInputColumn = "K_vv";
export var inputOptionRow = "K_qJ";
export var inputOptionColumn = "K_qK";